/* DEDashboardWrapper.tsx */
import React, {FC} from 'react'
import {useAuth} from '../../../modules/auth'
import Top5CardsSection from './Top5CardsSection'
import ShopifySalesLineChart from './RetailSalesLineChartWrapper'
import GetShopifyFinancialData from './Shopify_Financial_Data'

const DEDashboardWrapper: FC = () => {
  const {currentUser} = useAuth()

  return (
    <>
    

      <div className='row mb-5'>
        <div className='col-md-6'>
          {currentUser?.decoded?.dashboards?.some(
            ({name}) => name === 'Dashboard Overview/ Shopify Order Financial Data'
          ) && <GetShopifyFinancialData />}
        </div>
      </div>
      <div className='mb-7'>
        {currentUser?.decoded?.dashboards?.some(
          ({name}) => name === 'Dashboard Overview/ All Sales'
        ) && <ShopifySalesLineChart />}
      </div>

      <div className='row'>
        <div className='col-md-12'>
          {currentUser?.decoded?.dashboards?.some(
            ({name}) => name === 'Dashboard Overview/ Top 5'
          ) && <Top5CardsSection />}
        </div>
      </div>

      {/* Additional dashboard cards can be added below */}
    </>
  )
}

export default DEDashboardWrapper
